// Service detail content (EN/ES) — includes/not-included/rules per service
const COMMON_NOT = {
  en: ["Live calls (use Brand Office or paid add-on)", "Unlimited revisions", "Daily availability"],
  es: ["Llamadas en vivo (usa Brand Office o add-on de pago)", "Revisiones ilimitadas", "Disponibilidad diaria"],
};

const CONTENT = {
  "brand-scan": {
    lead: {
      en: "A clear diagnosis of an existing brand. Where it is strong, where it is weak, and what to fix in the next 30 days.",
      es: "Un diagnóstico claro de una marca existente. Qué funciona, qué no, y qué arreglar en los próximos 30 días.",
    },
    includes: {
      en: ["Brand diagnosis", "Scorecard across positioning, clarity, desirability, conversion", "Top problems", "Top opportunities", "30-day action plan", "Recommended next step"],
      es: ["Diagnóstico de marca", "Scorecard de posicionamiento, claridad, deseabilidad y conversión", "Principales problemas", "Principales oportunidades", "Plan de acción a 30 días", "Próximo paso recomendado"],
    },
    notIncluded: {
      en: ["Design execution / logo design", "Website build", "Social media management", "Revisions"],
      es: ["Ejecución de diseño / logo", "Construcción de web", "Gestión de redes", "Revisiones"],
    },
    rules: {
      en: "One payment. No call included. Delivered as PDF / strategic diagnosis with optional recorded walk-through. It is a diagnosis, not a production project.",
      es: "Un pago. Sin llamada incluida. Entrega en PDF / diagnóstico estratégico con walk-through grabado opcional. Es un diagnóstico, no un proyecto de producción.",
    },
  },
  "brand-development": {
    lead: {
      en: "Best for new brands, early brands, or ideas that need a first brand foundation. Build the foundation: who the brand is, what it stands for, how it positions, and how it goes to market.",
      es: "Ideal para marcas nuevas, marcas tempranas o ideas que necesitan una primera base de marca. Construye la base: qué es la marca, qué defiende, cómo se posiciona y cómo entra al mercado.",
    },
    includes: {
      en: ["Positioning", "Brand concept", "Key messages", "Brand design", "Final logo design + export package", "Core brand system: typography, colour, usage direction", "Offer structure", "Instagram / LinkedIn direction", "30-day launch plan"],
      es: ["Posicionamiento", "Concepto de marca", "Mensajes clave", "Brand design", "Diseño de logo final + paquete de export", "Sistema de marca base: tipografía, color, dirección de uso", "Estructura de oferta", "Dirección de Instagram / LinkedIn", "Plan de lanzamiento a 30 días"],
    },
    notIncluded: {
      en: ["Does not include extensive brand guidelines / brand book", "Packaging rollout", "Full collateral suite", "Full website design", "Ads management"],
      es: ["No incluye brand guidelines extensos / brand book", "Rollout de packaging", "Suite completa de collateral", "Diseño completo de web", "Gestión de ads"],
    },
    rules: {
      en: "10 business days after complete intake. Includes 2 adjustment rounds. Round 1: feedback on first direction. Round 2: final refinement. Extra revisions billed separately or moved into Brand Partner.",
      es: "10 días hábiles tras intake completo. Incluye 2 rondas de ajuste. Ronda 1: feedback de la primera dirección. Ronda 2: refinamiento final. Revisiones extra se cobran aparte o se mueven a Brand Partner.",
    },
  },
  "brand-strategy": {
    lead: {
      en: "Best for existing brands with identity or product, but lacking story, positioning, tone, campaign language, and cultural world. Define the meaning and the universe.",
      es: "Ideal para marcas existentes con identidad o producto, pero a las que les falta historia, posicionamiento, tono, lenguaje de campaña y mundo cultural. Define el significado y el universo.",
    },
    includes: {
      en: ["Positioning", "Category angle", "Brand narrative", "Tone of voice", "Messaging pillars", "Cultural references", "Brand systems & visual universe direction", "Content themes", "30-day narrative strategy"],
      es: ["Posicionamiento", "Ángulo de categoría", "Narrativa de marca", "Tono de voz", "Pilares de mensaje", "Referencias culturales", "Sistemas de marca y dirección de universo visual", "Temas de contenido", "Estrategia narrativa a 30 días"],
    },
    notIncluded: {
      en: ["Logo design", "Website design", "Content production", "Ads / posting"],
      es: ["Diseño de logo", "Diseño de web", "Producción de contenido", "Ads / posteo"],
    },
    rules: {
      en: "10 business days after complete intake. Includes 2 adjustment rounds. Use when the brand exists but lacks meaning, story, world, and a clear market point of view.",
      es: "10 días hábiles tras intake completo. Incluye 2 rondas de ajuste. Úsalo cuando la marca existe pero le falta significado, historia, mundo y un punto de vista claro de mercado.",
    },
  },
  "brand-partner": {
    lead: {
      en: "Ongoing brand direction through structured requests. Senior eyes on your launches, decks, content, designers, and decisions.",
      es: "Dirección de marca continua mediante requests estructurados. Ojos senior sobre tus lanzamientos, decks, contenido, diseñadores y decisiones.",
    },
    includes: {
      en: ["Includes Brand Scan + Brand Development + Brand Strategy", "Up to 4 strategic requests per month", "1 active request at a time", "Visual universe direction", "Monthly roadmap", "Messaging feedback", "Website / deck / content / campaign review"],
      es: ["Incluye Escaneo de marca + Desarrollo de marca + Estrategia de marca", "Hasta 4 requests estratégicos al mes", "1 request activo a la vez", "Dirección de universo visual", "Roadmap mensual", "Feedback de mensaje", "Review de web / deck / contenido / campaña"],
    },
    notIncluded: {
      en: ["Same-day urgent work", "Design / posting production", "Ads management", "Project management of external teams"],
      es: ["Trabajo urgente en el día", "Producción de diseño / posteo", "Gestión de ads", "Project management de equipos externos"],
    },
    rules: {
      en: "Not unlimited. Requests must include enough context and links / files. Unused requests do not roll over. Add-ons available: extra request $400–550, urgent $350–550, mini-sprint $1,100–2,200.",
      es: "No es ilimitado. Los requests deben incluir contexto suficiente y links / archivos. Los requests no usados no se acumulan. Add-ons disponibles: request extra $400–550, urgente $350–550, mini-sprint $1,100–2,200.",
    },
  },
  "brand-office": {
    lead: {
      en: "Direct strategic access for founders and companies that need deeper involvement and real consulting, not just productized deliverables.",
      es: "Acceso estratégico directo para fundadores y compañías que necesitan implicación más profunda y consulting real, no sólo entregables productizados.",
    },
    includes: {
      en: ["Creative Direction", "Brand Strategy", "Brand Future", "Brand Reputation", "Go-to-market narrative", "Founder narrative", "Campaign direction", "Website / deck / content review", "Team / agency feedback", "Monthly leadership roadmap"],
      es: ["Dirección Creativa", "Estrategia de Marca", "Futuro de Marca", "Reputación de Marca", "Narrativa de go-to-market", "Narrativa de fundador", "Dirección de campañas", "Review de web / deck / contenido", "Feedback de equipo / agencia", "Roadmap mensual de liderazgo"],
    },
    notIncluded: {
      en: ["Public price", "Without application"],
      es: ["Precio público", "Sin aplicación"],
    },
    rules: {
      en: "Minimum 3 months. Limited capacity. Application required. Price provided after review.",
      es: "Mínimo 3 meses. Capacidad limitada. Aplicación requerida. Precio entregado tras la revisión.",
    },
  },
};

export default CONTENT;
